import React, { useContext } from 'react';
import { AppContext } from '../../app-context';
import { get } from 'lodash';

function withRegion(_WrappedComponent) {
  return function ComponentWithRegion(props) {
    const { orderDetails } = useContext(AppContext);
    const isSaudiPaymentEnabled = get(orderDetails, 'order.isSaudiPaymentEnabled', false)
    return <_WrappedComponent {...props} isKsa={isSaudiPaymentEnabled} />;
  }
}

export default withRegion;
